import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import styles from './ProductCardMap.module.scss';
import Typography from '@/components/UI/typography/Typography';
import { ProductListLocation } from '../../types';
import useDrawer from '@/hooks/useDrawer';
import useDevice from '@/hooks/useDevice';
import ProductCardMapDrawer from './productCardMapDrawer/ProductCardMapDrawer';
type ProductCardMapProps = {
  id: number;
  location: ProductListLocation;
  isCarousel?: boolean;
  title: string;
};
const ProductCardMap: FC<ProductCardMapProps> = ({
  location,
  id,
  isCarousel,
  title
}) => {
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const {
    isMobile
  } = useDevice();
  const handlePreventChangeRoute = (e: React.MouseEvent<HTMLElement, MouseEvent>, id: number) => {
    e.preventDefault();
    drawerOpen(`MAP_${id}`);
  };
  return <>
      {!isCarousel && isMobile ? <Box className={styles['mobile-wrapper']}>
          <Box className={styles['show_on_map_section_mobile']} onClick={e => handlePreventChangeRoute(e, id)} data-name={'card_location'}>
            <Icon name="location" type="primary" />
            <Typography variant="bodyM" className={styles['show_on_map_text']}>
              {title}
            </Typography>
          </Box>
          <ProductCardMapDrawer open={isDrawerOpen(`MAP_${id}`)} handleClose={() => drawerClose()} lat={location?.latitude} long={location?.longitude} id={id} />
        </Box> : <Box className={styles['show_on_map_section_desktop']}>
          <Icon name="location" type="mediumEmphasis" size={16} />
          <Typography variant="bodyM" className={styles['village_text']}>
            {title}
          </Typography>
        </Box>}
    </>;
};
export default ProductCardMap;